module.exports = __webpack_public_path__ + "media/images/admin/icons/folder-plus-e573ef14703afc7d66f1891ca9c0ca0e.svg";